define("calendar/controllers/notes/new", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/utils/calendar/constants"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _tracking, _emberConcurrency, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/calendar/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let NewController = _exports.default = (_dec = (0, _service.inject)('note'), (_class = class NewController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "noteService", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "store", _descriptor7, this);
      _defineProperty(this, "queryParams", ['scheduled_time']);
      _initializerDefineProperty(this, "noteContent", _descriptor8, this);
      _initializerDefineProperty(this, "scheduled_time", _descriptor9, this);
      _initializerDefineProperty(this, "color", _descriptor10, this);
      _defineProperty(this, "addNewCalendarNote", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const note = this.store.createRecord('calendar-note', {
            group: this.currentGroup,
            noteContent: this.noteContent,
            scheduledTime: Number(this.scheduled_time) / 1000,
            color: this.color
          });
          try {
            const record = yield note.save();
            const payload = {
              group_id: this.currentGroup.id,
              timestamp: record.scheduledTime || null,
              user_id: this.currentUserModel.id,
              color: record.color || null
            };
            this.segment.track('created-note', payload);
            this.noteService.transitionToCalendar();
          } catch (adapterError) {
            if (adapterError?.errors?.firstObject?.detail === _constants.NOTE_ERRORS.SCHEDULE_OVERLAP) {
              this.alerts.alert(this.intl.t('alerts.calendar_notes.too_close_create.message'), {
                title: this.intl.t('alerts.calendar_notes.too_close_create.title')
              });
            } else {
              this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
                title: this.intl.t('alerts.calendar_notes.problem_saving.title')
              });
            }
            note.unloadRecord();
          }
        }
      }), null, "addNewCalendarNote", null));
      _defineProperty(this, "canClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.noteService.confirmClose.perform(this.hasChanges);
        }
      }), null, "canClose", null));
      _defineProperty(this, "copyToClipboard", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.noteService.copyToClipboard.perform(this.noteContent);
        }
      }), null, "copyToClipboard", null));
      _defineProperty(this, "deleteCalendarNote", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const didConfirm = yield this.dialogManager.confirmation(this.intl.t('calendar_notes.confirm_discard'), {
            confirmButton: this.intl.t('shared_words.discard')
          });
          if (!didConfirm) {
            return;
          }
          this.noteService.transitionToCalendar();
        }
      }), null, "deleteCalendarNote", null));
    }
    get allowSave() {
      return this.noteService.shouldAllowSave(this.noteContent);
    }
    get charactersRemaining() {
      return this.noteService.getCharactersRemaining(this.noteContent);
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get currentUserModel() {
      return this.auth.currentUserModel;
    }
    get hasChanges() {
      return this.noteContent.length > 0;
    }
    get showCharacterLimit() {
      return this.noteService.shouldShowCharacterLimit(this.noteContent);
    }
    clearExistingContent() {
      this.noteContent = '';
    }
    updateColor(color) {
      this.color = color;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "noteService", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "noteContent", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "scheduled_time", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "color", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "clearExistingContent", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearExistingContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateColor", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateColor"), _class.prototype)), _class));
});